import React, { FC, lazy, Suspense } from "react";

import { LoadingSection } from "nvent-web/components/LoadingSection";

export const LazyApp = lazy(() => import("./App"));

export const AsyncApp: FC = () => (
  <Suspense fallback={<LoadingSection />}>
    <LazyApp />
  </Suspense>
);
